import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EndpointFactory } from '../endpoint-factory.service';
import { ConfigurationService, ForceBaseUrl } from '../configuration/configuration.service';
import { Tenant } from '../../models/tenant';
import { IConvertMemberRequest, MemberRequestModel } from '../../models/member';
import { IDocumentType } from 'src/app/models/document';

@Injectable({
    providedIn: 'root'
})
export class TenantEndpoint extends EndpointFactory {

    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('tenant', force) + 'tenant';
    }

    getAllTenantsUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('tenant', force) + 'tenant/all';
    }

    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {

        super(http, configurations, injector);
    }

    public getAllTenants(): Observable<Tenant[]> {

        const endpointUrl = `${this.getAllTenantsUrl()}`;

        return this.http.get<Tenant[]>(endpointUrl).pipe<Tenant[]>(
            catchError(error => {
                return this.handleError(error);
            }));
    }
    getOriginTypeEndpoint<T>(tenantId: string): Observable<T> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/getorigintype`;
        return this.http.get<T>(endpointUrl).pipe<T>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    addMemberEndpoint<T>(tenantId: string, request: MemberRequestModel): Observable<T> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/member/add`;

        return this.http.put<T>(endpointUrl, request).pipe<T>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    convertMemberEndpoint<T>(tenantId: string, request: IConvertMemberRequest, targetUrl: string): Observable<T> {
        const endpointUrl = targetUrl || `${this.getServiceBaseUrl()}/${tenantId}/member/convert`;

        return this.http.put<T>(endpointUrl, request).pipe<T>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    getReasonTypeEndpoint<T>(tenantId: string): Observable<T> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/getreasontype`;
        return this.http.get<T>(endpointUrl).pipe<T>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    getDispositionEndpoint<T>(tenantId: string): Observable<T> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/getdispositiontype`;
        return this.http.get<T>(endpointUrl).pipe<T>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    getDirectionTypeEndpoint<T>(tenantId: string): Observable<T> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/getdirectiontype`;
        return this.http.get<T>(endpointUrl).pipe<T>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    getDocumentTypeEndpoint(tenantId: string): Observable<{ types: IDocumentType[] }> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/getdocumenttype`;
        return this.http.get<{ types: IDocumentType[] }>(endpointUrl).pipe(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    getConfiguration(tenantId: string): Promise<any> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/configuration`;
        return this.http.get<any>(endpointUrl).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    saveConfiguration(tenantId: string, data: any) {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}/configuration`;
        return this.http.put<any>(endpointUrl, data).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

}
